export default {
  navigationBarTitleText: '填写推介人'
};
